const reducersName = 'configuration'

export const configurationSelectors = {
	getAll: (state) => state[reducersName],
}
